import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ReactPaginate from 'react-paginate'
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import '../dashboard/AdminDashboard/pages/UserCampign/UserCampign.css'
import { FaFileCsv } from 'react-icons/fa'
import { toast } from 'react-toastify'
import { FaPlay, FaPause } from 'react-icons/fa'
import ReactPlayer from 'react-player'
import { ImFolderUpload } from 'react-icons/im'
import { FaTrash } from 'react-icons/fa' // Added trash icon
import { IoIosArrowRoundForward, IoIosArrowRoundBack } from 'react-icons/io'
import { AiOutlineDownload } from 'react-icons/ai'
import { FaCirclePlay } from 'react-icons/fa6'
import { MdErrorOutline } from 'react-icons/md'
import { FaCommentDots } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import AutoApprovalPeriodUpdateForm from './AutoApprovalPeriodUpdateForm'

let headers = [
  'ID',
  'Company Name',
  'Customer Name',
  'Designation',
  'Email',
  'Mobile Number',
  'City',
  'Country',
  'Lead Comments',
  'Play',
  'Action',
  'D/L Audio',
  'Status',
  'Date'
]
let headers2 = [
  'ID',
  'Company Name',
  'Customer Name',
  'Designation',
  'Email',
  'Mobile Number',
  'City',
  'Country',
  'Lead Comments',
  'Audio',
  'Play',
  'Action',
  'D/L Audio',
  'Status',
  'Delete',
  'Date',
  "Change Status"
]
const ALL_COLUMNS = [
  "ID",'Company Name', "Customer Name", "Designation", "Email", "Mobile Number",
  "City", "Country", "Lead Comments", "Audio", "Play", "Action", "D/L Audio",
  "Status", "Delete", "Date", "Change Status"
];

const AdminCsv = () => {
  const location = useLocation()
  const campaignId = location.pathname.split('/').pop() // Extract campaign ID
  const [CsvData, setCsvData] = useState([])
  const [pageNumber, setPageNumber] = useState(0)
  const campaignsPerPage = 10 // You can adjust this value as per your requirement
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const [visibleColumns, setVisibleColumns] = useState(ALL_COLUMNS);
  const [showMore, setShowMore] = useState([]);
  const [editingMobile, setEditingMobile] = useState(null);
  const [newMobileNumber, setNewMobileNumber] = useState("");
  const [countryCode, setCountryCode] = useState("+91"); // Default to India country code

  const user = useSelector(state => state.userReducer)

  const contentMaxLength = 50
  console.log(CsvData)
  const handleAudioUpload = async (dataId, file) => {
    try {
      const formData = new FormData()
      formData.append('audio', file)
      formData.append('dataId', dataId) // Updated to include dataId
      await axios.post('/api/audio/uploads', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      toast.success('Audio uploaded successfully')
      window.location.reload()
    } catch (error) {
      toast.error('Error uploading audio')
      console.error(error)
    }
  }

  const [hoverIndex, setHoverIndex] = useState(null) // Add hoverIndex state

  // Update renderParagraph function
  const renderParagraph = (content, index) => {
    if (
      typeof content !== 'string' ||
      content === null ||
      content === undefined
    ) {
      return '' // or handle the case when content is not a string
    }

    return (
      <div
        style={{ position: 'relative', display: 'inline-block' }}
        onMouseEnter={() => {
          console.log(`Hovered on comment index: ${index}`)
          setHoverIndex(index)
        }}
        onMouseLeave={() => {
          console.log(`Mouse left comment index: ${index}`)
          setHoverIndex(null)
        }}
      >
        <FaCommentDots
          size={20}
          style={{ cursor: 'pointer', color: '#418af6' }}
        />
        {hoverIndex === index && (
          <span
            style={{
              visibility: 'visible',
              width: '200px',
              backgroundColor: '#f9f9f9',
              color: '#000',
              textAlign: 'center',
              borderRadius: '6px',
              padding: '5px 10px',
              position: 'absolute',
              zIndex: 1,
              bottom: '125%', // Adjust as needed
              left: '50%',
              marginLeft: '-100px', // Adjust as needed
              boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)'
            }}
          >
            {content}
          </span>
        )}
      </div>
    )
  }

  useEffect(() => {
    const fetchCampaignData = async () => {
      try {
        const response = await axios.get(`/csv/getSinglecsv/${campaignId}`)
        setCsvData(response.data[0]?.data || []) // Check if response.data[0]?.data is undefined
        setShowMore(new Array(response.data[0]?.data?.length || 0).fill(false)) // Initialize with false values
      } catch (error) {
        if (error.response && error.response.status === 404) {
          setError('Campaign not found')
        } else {
          setError(error.message)
        }
      } finally {
        setLoading(false)
      }
    }

    fetchCampaignData()
  }, [campaignId])


  // Fetch visible columns
  useEffect(() => {
    const fetchColumns = async () => {
      try {
        const res = await axios.get(`/compaign/getColumnVisibility/${campaignId}`);
        if (res.data.columns) setVisibleColumns(res.data.columns);
      } catch {
        setVisibleColumns(ALL_COLUMNS);
      }
    };
    fetchColumns();
  }, [campaignId]);

  // Toggle column and persist
  const handleToggleColumn = async (col) => {
    let updated;
    setVisibleColumns(prev => {
      updated = prev.includes(col) ? prev.filter(c => c !== col) : [...prev, col];
      return updated;
    });
    await axios.post('/compaign/setColumnVisibility', {
      campaignId,
      columns: updated
    });
  };

  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const pageCount = Math.ceil(CsvData?.length / campaignsPerPage)

  const handleDownload = () => {
    axios
      .post('/csv/download', { campaignId }, { responseType: 'blob' })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'data.csv')
        document.body.appendChild(link)
        link.click()
      })
      .catch(error => {
        console.error('Error downloading data:', error)
      })
  }

  const handleDownloadAudio = async filename => {
    try {
      const response = await axios.get(`/api/audio/${filename}/download`, {
        responseType: 'blob'
      })
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
    } catch (error) {
      console.error('Error downloading audio:', error)
    }
  }

  function togglePlay (audioId) {
    const audio = document.getElementById(audioId)
    if (audio.paused) {
      audio.play()
    } else {
      audio.pause()
    }
  }
  const handleDeleteCsvData = async dataId => {
    try {
      await axios.delete(`/csv/deleteCSVData/${campaignId}/data/${dataId}`)
      toast.success('Data deleted successfully')
      // Refresh CSV data after deletion
      const response = await axios.get(`/csv/getSinglecsv/${campaignId}`)
      setCsvData(response.data[0]?.data || [])
    } catch (error) {
      toast.error('Error deleting data')
      console.error(error)
    }
  }

  // Function to handle deletion of audio
  const handleDelete = async listingId => {
    try {
      await axios.delete(`/api/audio/delete/${listingId}`)
      toast.success('Audio deleted successfully')
      // Refresh listings after deletion
      const response = await axios.get(`/csv/getSinglecsv/${campaignId}`)
      setCsvData(response.data[0]?.data || [])
    } catch (error) {
      toast.error('Error deleting audio')
      console.error(error)
    }
  }

  const handleChangeStatus = async (_id, status, campaignId) => {
    try {
      await axios.post('/csv/adminChangeLeadStatus', {
        _id,
        status,
        campaignId,
      });
      toast.success('Lead status updated!');
      // Optionally refresh data here
    } catch (err) {
      toast.error('Failed to update lead status');
    }
  };

  const handleUpdateMobileNumber = async (dataId) => {
    try {
      if (!newMobileNumber) {
        toast.error('Mobile number cannot be empty');
        return;
      }
      

      const mobileWithCode = `${countryCode}${newMobileNumber}`;
  
      const mobileRegex = /^\+[0-9]{1,4}[0-9]{7,15}$/; 
      if (!mobileRegex.test(mobileWithCode)) {
        toast.error('Please enter a valid mobile number with country code');
        return;
      }
  
      const response = await axios.post('/csv/updateMobileNumber', {
        _id: dataId,
        mobileNumber: mobileWithCode
      });
  
      const updatedCsvData = [...CsvData];
      const dataIndex = updatedCsvData.findIndex(item => item._id === dataId);
      
      if (dataIndex !== -1) {
        updatedCsvData[dataIndex].mobileNumber = mobileWithCode;
        setCsvData(updatedCsvData);
      }
  
        setEditingMobile(null); 
      toast.success('Mobile number updated successfully');
    } catch (error) {
      console.error('Error updating mobile number:', error);
      toast.error('Failed to update mobile number');
    }
  };

  return (
    <div>
    {user.department === "Superadmin" && (
      <div style={{ marginBottom: 16 }}>
        <strong>Show/Hide Columns: </strong>
        {ALL_COLUMNS.map(col => (
          <label key={col} style={{ marginRight: 10 }}>
            <input
              type="checkbox"
              checked={visibleColumns.includes(col)}
              onChange={() => handleToggleColumn(col)}
            />
            {col}
          </label>
        ))}
      </div>
    )}
    {loading ? (
      <p>Loading...</p>
    ) : error ? (
      <p>{error}</p>
    ) : (
      <>
        {CsvData.length === 0 ? (
          <p>No Data found</p>
        ) : (
          <div className="table-container" style={{
            borderRadius: "20px",
            padding: "20px",
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2)",
            marginBottom: "40px",
            marginTop: "30px",
          }}>
            <div className="d-flex align-items-center justify-content-between mb-3">
              <h3 className="fw-bold">Lead Details</h3>
              <AutoApprovalPeriodUpdateForm />
            </div>
  
            <div style={{
              display: "flex",
              justifyContent: "end",
              paddingBottom: "20px",
            }}>
              <button onClick={() => handleDownload(CsvData._id)} style={{
                backgroundColor: "#55b56d",
                color: "white",
                border: "none",
                padding: "8px 16px",
                borderRadius: "10px",
                cursor: "pointer",
              }}>
                Download
              </button>
            </div>
  
            <table style={{
              borderCollapse: "collapse",
              borderRadius: "10px",
              overflow: "hidden",
              width: "100%",
            }}>
              <thead>
                <tr>
                  {(user.department === "Superadmin" ? headers2 : headers).map((header) => 
                    visibleColumns.includes(header) && (
                      <th key={header} style={{
                        fontSize: "13px",
                        padding: "20px 10px",
                        background: "#F5F7FB",
                        color: "#989898",
                      }}>
                        {header}
                      </th>
                    )
                  )}
                </tr>
              </thead>
              <tbody>
                {CsvData.slice(pageNumber * campaignsPerPage, (pageNumber + 1) * campaignsPerPage).map((csv, index) => (
                  <tr key={csv._id}>
                    {visibleColumns.includes('ID') && <td>{pageNumber * campaignsPerPage + index + 1}</td>}
                    {visibleColumns.includes('Company Name') && <td>{csv.companyName}</td>}
                    {visibleColumns.includes('Customer Name') && <td>{csv.customerName}</td>}
                    {visibleColumns.includes('Designation') && <td>{csv.designation}</td>}
                    {visibleColumns.includes('Email') && <td>{csv.email}</td>}
                    {visibleColumns.includes('Mobile Number') && (
                      <td>
                        {editingMobile === csv._id ? (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                              <div style={{ display: 'flex', marginBottom: '4px' }}>
                                <select
                                  value={countryCode}
                                  onChange={(e) => setCountryCode(e.target.value)}
                                  style={{ padding: '4px', marginRight: '5px', width: '70px' }}
                                >
                                  <option value="+91">+91 (India)</option>
                                  <option value="+1">+1 (US/Canada)</option>
                                  <option value="+44">+44 (UK)</option>
                                  <option value="+61">+61 (Australia)</option>
                                  <option value="+65">+65 (Singapore)</option>
                                  <option value="+971">+971 (UAE)</option>
                                  <option value="+86">+86 (China)</option>
                                  <option value="+49">+49 (Germany)</option>
                                </select>
                                <input
                                  type="tel"
                                  value={newMobileNumber}
                                  onChange={(e) => setNewMobileNumber(e.target.value)}
                                  placeholder="Mobile Number"
                                  style={{ width: '120px', padding: '4px' }}
                                />
                              </div>
                            </div>
                            <button
                              onClick={() => handleUpdateMobileNumber(csv._id)}
                              style={{ 
                                backgroundColor: '#4CAF50', 
                                color: 'white', 
                                border: 'none',
                                border: 'none', 
                                padding: '5px 8px',
                                borderRadius: '3px',
                                marginRight: '3px',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              Save
                            </button>
                            <button
                              onClick={() => setEditingMobile(null)}
                              style={{ 
                                backgroundColor: '#f44336', 
                                color: 'white', 
                                border: 'none', 
                                padding: '5px 8px',
                                borderRadius: '3px',
                                cursor: 'pointer',
                                fontSize: '12px'
                              }}
                            >
                              Cancel
                            </button>
                          </div>
                        ) : (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span>{csv.mobileNumber}</span>
                            {user.department === "Superadmin" && (
                              <button
                                onClick={() => {
                                  setEditingMobile(csv._id);
                                  // Get the current mobile number to edit
                                  const mobileNum = csv.mobileNumber || '';
                                  
                                  // Use common country codes to detect and separate
                                  const countryCodes = [
                                    '+91', '+1', '+44', '+61', '+65', '+971', '+86', '+49'
                                  ];
                                  
                                  // Find if the mobile number starts with any country code
                                  let foundCode = null;
                                  let numberPart = mobileNum;
                                  
                                  for (const code of countryCodes) {
                                    if (mobileNum.startsWith(code)) {
                                      foundCode = code;
                                      numberPart = mobileNum.substring(code.length);
                                      break;
                                    }
                                  }
                                  
                                  // If no known country code found but starts with +, try to extract it
                                  if (!foundCode && mobileNum.startsWith('+')) {
                                    const match = mobileNum.match(/^(\+[0-9]{1,4})([0-9]+)/);
                                    if (match && match.length >= 3) {
                                      foundCode = match[1];
                                      numberPart = match[2];
                                    }
                                  }
                                  
                                  // Set the country code and number
                                  setCountryCode(foundCode || '+91'); // Default to India if no code found
                                  setNewMobileNumber(foundCode ? numberPart : mobileNum);
                                  
                                  console.log('Setting country code:', foundCode || '+91');
                                  console.log('Setting phone number:', foundCode ? numberPart : mobileNum);
                                }}
                                style={{ 
                                  backgroundColor: 'transparent', 
                                  color: '#007bff', 
                                  border: 'none', 
                                  cursor: 'pointer',
                                  marginLeft: '5px',
                                  fontSize: '12px'
                                }}
                              >
                                Edit
                              </button>
                            )}
                          </div>
                        )}
                      </td>
                    )}
                    {visibleColumns.includes('City') && <td>{csv.city}</td>}
                    {visibleColumns.includes('Country') && <td>{csv.state}</td>}
                    {visibleColumns.includes('Lead Comments') && <td>{renderParagraph(csv.leadComments, index)}</td>}
                    
                    {user.department === "Superadmin" && visibleColumns.includes('Audio') && (
                      <td style={{ textAlign: "center", padding: "0" }}>
                        <label htmlFor={`audio-upload-${csv._id}`} className="upload-btn">
                          <ImFolderUpload size={20} style={{ color: "#007bff", margin: "20px" }} />
                        </label>
                        <input
                          type="file"
                          id={`audio-upload-${csv._id}`}
                          onChange={(e) => handleAudioUpload(csv._id, e.target.files[0])}
                          style={{ display: "none" }}
                          accept="audio/*"
                        />
                      </td>
                    )}
  
                    {visibleColumns.includes('Play') && (
                      <td>
                        {csv.audio && csv.audio.audio && csv.audio.audio.filePath ? (
                          <li key={csv._id} style={{ color: "blue" }}>
                            <audio id={`audio-${csv._id}`} src={`/api/audio/${csv.audio.audio.filename}.gz`} type="audio/mpeg"></audio>
                            <div onClick={() => togglePlay(`audio-${csv._id}`)} style={{ cursor: "pointer" }}>
                              <FaCirclePlay size={25} style={{ color: "#F7A600" }} />
                            </div>
                          </li>
                        ) : (
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "12px" }}>
                            <MdErrorOutline size={20} style={{ color: "red" }} />
                            Audio
                          </div>
                        )}
                      </td>
                    )}
  
                    {visibleColumns.includes('Action') && (
                      <td style={{ textAlign: "center", padding: "0" }}>
                        {user.department === "Superadmin" && csv.audio ? (
                          <button style={{ border: "none" }} onClick={() => handleDelete(csv.audio._id)}>
                            <FaTrash size={15} style={{ color: "red", margin: "8px", border: "none" }} />
                          </button>
                        ) : (
                          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "12px" }}>
                            <MdErrorOutline size={20} style={{ color: "red" }} />
                            Audio
                          </div>
                        )}
                      </td>
                    )}
  
                    {visibleColumns.includes('D/L Audio') && (
                      <td style={{ textAlign: "center" }}>
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", fontSize: "12px" }}>
                          {csv.audio ? (
                            <button style={{ border: "none" }} onClick={() => handleDownloadAudio(csv.audio.audio.filename)}>
                              <AiOutlineDownload size={15} style={{ color: "#28a745", margin: "8px", border: "none" }} />
                            </button>
                          ) : (
                            <MdErrorOutline size={20} style={{ color: "red" }} />
                          )}
                        </div>
                      </td>
                    )}
  
                    {visibleColumns.includes('Status') && (
                      <td style={{ textAlign: "center" }}>
                        <div style={{
                          color: csv.status === "rejected" ? "red" : "green",
                          cursor: csv.status === "rejected" ? "pointer" : "default",
                          textDecoration: csv.status === "rejected" ? "underline" : "none",
                          textTransform: "capitalize",
                        }} title={csv.status === "rejected" ? `Rejection Reason: ${csv.rejectionReason}` : ""}>
                          {csv.status === "approved" ? (csv.isAutoApproved ? "Auto Approved" : "Manual Approved") : csv.status}
                        </div>
                      </td>
                    )}
  
                    {visibleColumns.includes('Date') && <td>{new Date(csv.createdAt).toLocaleDateString()}</td>}

                        {visibleColumns.includes('Delete') &&  user.department === 'Superadmin' && (


                          <td style={{ textAlign: 'center' }}>
                            <button
                              onClick={() => handleDeleteCsvData(csv._id)}
                              style={{
                                backgroundColor: 'transparent',
                                border: 'none',
                                cursor: 'pointer'
                              }}
                            >
                              <FaTrash color='red' size={20} />
                            </button>
                          </td>
                        )}
  
                    {visibleColumns.includes('Change Status') && user.department === "Superadmin" && (
                      <td className="text-center">
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}>
                          <label style={{ fontSize: 12, color: "#555", marginBottom: 2 }}>Change Status:</label>
                          <select className="form-select" style={{ width: 130, display: "inline-block", fontSize: 14, padding: "2px 8px", borderRadius: 4, border: "1px solid #ccc" }} value={csv.status} onChange={async (e) => {
                            const newStatus = e.target.value;
                            let reason = "";
                            if (newStatus === "rejected") {
                              reason = prompt("Enter rejection reason:", csv.rejectionReason || "") || "";
                            }
                            await handleChangeStatus(csv._id, newStatus, reason, campaignId);
                          }}>
                            <option value="in review">In Review</option>
                            <option value="approved">Approved</option>
                            <option value="rejected">Rejected</option>
                          </select>
                        </div>
                      </td>
                    )}
                  </tr>
                ))}
              </tbody>
            </table>
  
            <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "10px",
                  }}
                >
                  <div>
                    <button
                      onClick={() => changePage({ selected: pageNumber - 1 })}
                      disabled={pageNumber === 0}
                      style={{
                        color: "black",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        border: "none",
                        marginRight: "10px",
                      }}
                    >
                      <span>
                        <IoIosArrowRoundBack size={25} />
                      </span>
                      Previous
                    </button>
                    <button
                      onClick={() => changePage({ selected: pageNumber + 1 })}
                      disabled={pageNumber === pageCount - 1}
                      style={{
                        color: "black",
                        padding: "5px 10px",
                        borderRadius: "5px",
                        border: "none",
                      }}
                    >
                      Next
                      <span>
                        <IoIosArrowRoundForward size={25} />
                      </span>
                    </button>
                  </div>
                  <div>
                    <span style={{ color: "#0A58CA" }}>
                      Page {pageNumber + 1} of {pageCount}
                    </span>
                  </div>
                </div>
          </div>
        )}
      </>
    )}
  </div>
  
  );
}


export default AdminCsv